import React from 'react';

const SmsCenterIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="55"
    height="48"
    viewBox="0 0 55 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M21 31.5752V28.3325V26.3658H23.322V31.1627C23.322 31.7606 23.5547 32.335 23.971 32.7643C24.4042 33.211 25 33.4632 25.6224 33.4632H30.5366V42.5273L39.5756 33.4632H51.0965C51.5244 33.4632 51.934 33.2898 52.2318 32.9827C52.518 32.6876 52.678 32.2927 52.678 31.8816V16.8968C52.678 16.2241 52.4162 15.5779 51.9479 15.0951C51.4605 14.5925 50.7902 14.3088 50.0901 14.3088H40.9024V12H50.4659C51.4699 12 52.4455 12.3332 53.2397 12.9474C54.35 13.8061 55 15.1305 55 16.5341V30.9766C55 32.5292 54.2208 33.9782 52.9256 34.8344C52.1692 35.3344 51.2824 35.601 50.3756 35.601H40.239L28.2146 48V35.601H25.0258C23.9367 35.601 22.894 35.1597 22.1358 34.3778C21.4074 33.6267 21 32.6215 21 31.5752Z"
      fill="#75C405"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.45674 26.4756V41.3053L22.2864 26.4756H37.1922C38.2164 26.4756 39.1987 26.0688 39.9229 25.3445C40.6471 24.6203 41.054 23.6381 41.054 22.6139V3.86174C41.054 2.83755 40.6471 1.8553 39.9229 1.13108C39.1987 0.406861 38.2164 0 37.1922 0H3.86174C2.83754 0 1.8553 0.406861 1.13108 1.13108C0.406861 1.8553 0 2.83755 0 3.86174V22.6139C0 23.6381 0.406861 24.6203 1.13108 25.3445C1.8553 26.0688 2.83755 26.4756 3.86174 26.4756H7.45674ZM4.3239 24.2967H9.46766V36.3615L21.5325 24.2967H36.4197C37.0266 24.2967 37.6087 24.0556 38.0379 23.6264C38.467 23.1972 38.7081 22.6152 38.7081 22.0082V4.63381C38.7081 4.02688 38.467 3.4448 38.0379 3.01564C37.6087 2.58647 37.0266 2.34537 36.4197 2.34537H4.3239C3.7549 2.34537 3.20921 2.5714 2.80686 2.97375C2.40452 3.37609 2.17849 3.92178 2.17849 4.49078V22.1513C2.17849 22.7203 2.40452 23.266 2.80686 23.6683C3.20921 24.0706 3.7549 24.2967 4.3239 24.2967Z"
      fill="#005CA9"
    />
  </svg>
);

export default SmsCenterIcon;
